import type { ReactNode } from 'react';

export enum Theme {
  LIGHT = 'light',
  DARK = 'dark',
  SYSTEM = 'system',
}

export enum ClientTheme {
  NH1816 = 'theme-nh1816',
}

export type ThemeState = {
  theme: Theme;
  toggleTheme: () => void;
  clientTheme?: ClientTheme;
  setClientTheme: (clientTheme: ClientTheme) => void;
};

export interface ThemeLayoutProps {
  children: ReactNode;
}
